import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Typewriter from 'typewriter-effect';
import Fade from 'react-reveal';
import endpoints from '../constants/endpoints';
import Social from './Social';
import FallbackSpinner from './FallbackSpinner';

const styles = {
  nameStyle: {
    fontSize: '5em',
  },
  inlineChild: {
    display: 'inline-block',
  },
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

function Home() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.home, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  return data ? (
    <>
      <Helmet>
        <title>Faisal Imran | React Native & Full Stack Developer - Saudi Arabia</title>
        <meta name="description" content="Faisal Imran — React Native & MERN Stack Developer based in Saudi Arabia. Building scalable mobile apps, AI-powered systems, and full-stack solutions with 3+ years of experience." />
        <link rel="canonical" href="https://faisalcode.com/" />
      </Helmet>
      <Fade>
        <section style={styles.mainContainer} aria-label="Introduction">
          <h1 style={styles.nameStyle}>{data?.name}</h1>
          <div style={{ flexDirection: 'row' }}>
            <h2 style={styles.inlineChild}>I&apos;m&nbsp;</h2>
            <Typewriter
              options={{
                loop: true,
                autoStart: true,
                strings: data?.roles,
              }}
            />
          </div>
          <Social />
        </section>
      </Fade>
    </>
  ) : <FallbackSpinner />;
}

export default Home;
